import { CheckboxState } from 'Components/designSystem';

export default function getSelectAllState<T>(items: T[], selection: string[]) {
    if (!selection.length) {
        return CheckboxState.NotChecked;
    }

    if (selection.length === items.length) {
        return CheckboxState.Checked;
    }

    return CheckboxState.PartlyChecked;
}
